import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { useMeContext } from '~/modules/me';

export const RESOURCE_ALLOCATIONS_FOR_USER_QUERY = gql`
  query GetAllocationsForResourceUser(
    $userUri: String
    $startDate: String
    $endDate: String
    $limit: Int
  ) {
    resourceAllocations(
      userUri: $userUri
      startDate: $startDate
      endDate: $endDate
      limit: $limit
    ) {
      resourceAllocations {
        id
        projectUri
        project {
          id
          displayText
        }
        allocationStatus
        scheduleRules {
          dateRange {
            startDate
            endDate
          }
          do
        }
      }
    }
  }
`;

export const RESOURCE_ALLOCATIONS_FOR_USER_QUERY_V2 = gql`
  query GetAllocationsForResourceUser2(
    $userUri: String
    $startDate: String
    $endDate: String
    $limit: Int
  ) {
    resourceAllocations: resourceAllocations2(
      userUri: $userUri
      startDate: $startDate
      endDate: $endDate
      limit: $limit
    ) {
      resourceAllocations {
        id
        projectUri
        project {
          id
          displayText
        }
        allocationStatus
        scheduleRules {
          dateRange {
            startDate
            endDate
          }
          do
        }
      }
    }
  }
`;

const useAllocationsForResourceUser = ({ userUri, dateRange }) => {
  const {
    featureFlags: {
      isPsaRmpTaskAllocation1Enabled,
      isPsaRmpEnhancedProjectManagerPersonaEnabled
    }
  } = useMeContext();

  const { loading, error, data } = useQuery(
    isPsaRmpTaskAllocation1Enabled &&
      isPsaRmpEnhancedProjectManagerPersonaEnabled
      ? RESOURCE_ALLOCATIONS_FOR_USER_QUERY_V2
      : RESOURCE_ALLOCATIONS_FOR_USER_QUERY,
    {
      variables: {
        userUri,
        startDate: dateRange ? dateRange.start : null,
        endDate: dateRange ? dateRange.end : null,
        limit: 500
      },
      fetchPolicy: 'cache-and-network'
    }
  );

  const allocations =
    data &&
    data.resourceAllocations &&
    data.resourceAllocations.resourceAllocations;

  return {
    loading,
    allocations: allocations || [],
    error
  };
};

export default useAllocationsForResourceUser;
